import { GET_PORTOFOLIO_ERROR, GET_PORTOFOLIO_START, GET_PORTOFOLIO_SUCCESS } from '../../types';

export default function get_portofolio(state, action) {
  switch (action.type) {
    case GET_PORTOFOLIO_START:
      return { ...state };
    case GET_PORTOFOLIO_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_PORTOFOLIO_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
